














































import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { ClassCardData } from '../../interfaces/character/classCard';
import ClassCard from './classCard.vue';

@Component({ components: { ClassCard } })
export default class ClassCardSelectionDialog extends Vue {
  @Prop()
  public open!: boolean;

  @Prop({ default: false })
  public saving!: boolean;

  @Prop()
  public classOfCharacter!: string;

  @Prop()
  public initiallySelectedClassCards!: ClassCardData[];

  get classCards() {
    return this.$store.getters.classCardsByClass(this.classOfCharacter);
  }

  private selectedClassCards: string[] = [];

  private cardsLoading = true;

  @Watch('open')
  private onOpen(isOpen: boolean) {
    if (isOpen) {
      this.selectedClassCards = this.initiallySelectedClassCards.map((card) => card.id as string);
      if (this.cardsLoading) {
        this.$store.dispatch('loadClassCards', this.classOfCharacter).then(() => {
          this.cardsLoading = false;
        });
      }
    }
  }

  private onSaveClick() {
    // Retrieve the classCard objects to emit
    const classCardsToEmit = this.classCards.filter((classCard) =>
      this.selectedClassCards.includes(classCard.id as string),
    );
    this.$emit('dialog:save', classCardsToEmit);
  }
}
